/**
 * @generated SignedSource<<c52ef85fcfe8e229540b4baefe3d178f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MATTeacherAuthorityEnum = "normal" | "superuser" | "%future added value";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type MATTeacherFilter = {
  AND?: MATTeacherFilter | null;
  NOT?: MATTeacherFilter | null;
  OR?: MATTeacherFilter | null;
  authority_Exact?: MATTeacherAuthorityEnum | null;
  authority_In?: ReadonlyArray<MATTeacherAuthorityEnum> | null;
  branch_Exact?: string | null;
  branch_In?: ReadonlyArray<string> | null;
  classroom_In?: ReadonlyArray<string> | null;
  created_Gte?: any | null;
  created_Lte?: any | null;
  distinct?: boolean | null;
  email_Exact?: string | null;
  email_In?: ReadonlyArray<string> | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  isVerified_Exact?: boolean | null;
  modified_Gte?: any | null;
  modified_Lte?: any | null;
  organization_Exact?: string | null;
  search?: string | null;
  username_Exact?: string | null;
};
export type MATTeacherOrder = {
  realname?: Ordering | null;
};
export type OrganizationId_organizationTeachersQuery$variables = {
  filters?: MATTeacherFilter | null;
  order?: MATTeacherOrder | null;
  page?: number | null;
  pageSize?: number | null;
};
export type OrganizationId_organizationTeachersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MATTeacherWindowPaginator_query">;
};
export type OrganizationId_organizationTeachersQuery = {
  response: OrganizationId_organizationTeachersQuery$data;
  variables: OrganizationId_organizationTeachersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "page"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageSize"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "pageSize",
    "variableName": "pageSize"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "page",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationId_organizationTeachersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "MATTeacherWindowPaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrganizationId_organizationTeachersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MATTeacherConnection",
        "kind": "LinkedField",
        "name": "organizationTeachers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pages",
            "kind": "LinkedField",
            "name": "pages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCurrent",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "next",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "previous",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MATTeacherEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MATTeacher",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneNumber",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "399433e6de6967373bea931acf60df74",
    "id": null,
    "metadata": {},
    "name": "OrganizationId_organizationTeachersQuery",
    "operationKind": "query",
    "text": "query OrganizationId_organizationTeachersQuery(\n  $filters: MATTeacherFilter\n  $order: MATTeacherOrder\n  $page: Int\n  $pageSize: Int\n) {\n  ...MATTeacherWindowPaginator_query_36liK3\n}\n\nfragment MATTeacherConnectionDataTable_matTeacherConnection on MATTeacherConnection {\n  edges {\n    node {\n      id\n      email\n      phoneNumber\n    }\n  }\n}\n\nfragment MATTeacherWindowPaginator_query_36liK3 on Query {\n  organizationTeachers(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {\n    totalCount\n    pages {\n      ...Pagination_pages\n    }\n    edges {\n      node {\n        id\n      }\n    }\n    ...MATTeacherConnectionDataTable_matTeacherConnection\n  }\n}\n\nfragment Pagination_pages on Pages {\n  first {\n    page\n  }\n  around {\n    page\n    isCurrent\n  }\n  last {\n    page\n  }\n  next {\n    page\n  }\n  previous {\n    page\n  }\n}\n"
  }
};
})();

(node as any).hash = "06c5a2b130ca8412ea5aa5ca992c48e6";

export default node;
